import { render, staticRenderFns } from "./ProprieteBool.vue?vue&type=template&id=4a826990&scoped=true&"
import script from "./ProprieteBool.vue?vue&type=script&lang=js&"
export * from "./ProprieteBool.vue?vue&type=script&lang=js&"
import style0 from "./ProprieteBool.vue?vue&type=style&index=0&id=4a826990&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a826990",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
